import React from "react"
import styled from "styled-components"
import {Badge} from "./Badge"
import {ReportCard} from "./ReportCard"

const Badges = (props) => {
  return (
    <OuterDiv>
      {props.badges.map((badge, badgeKey) => {
        return (
          <CardDiv key={badgeKey}>
            <ReportCard collapsible={false} padded={false}>
              <Badge
                chart={badge.chart}
                name={badge.name}
                renderValue={props.renderValue}
                value={badge.value}
              />
            </ReportCard>
          </CardDiv>
        )
      })}
    </OuterDiv>
  )
}

const CardDiv = styled.div`
  flex-grow: 1;
  padding: 0 ${(props) => props.theme.gutter / 4}px;
  position: relative;
  width: ${100 / 3}%;
`

const OuterDiv = styled.div`
  display: flex;
  margin-left: -${(props) => props.theme.gutter / 4}px;
  margin-right: -${(props) => props.theme.gutter / 4}px;
`

export {Badges}
